import { cva, type VariantProps } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
  'inline-flex items-center rounded-full whitespace-nowrap px-2 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2',
  {
    variants: {
      variant: {
        blue: 'bg-blue-600 text-white',
        gray: 'bg-gray-100'
      },
      rounded: {
        md: 'rounded-md',
        full: 'rounded-full'
      }
    },
    defaultVariants: {
      variant: 'blue',
      rounded: 'md'
    }
  }
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
